import { createFileRoute } from '@tanstack/react-router';
import { SpedFiscalListagem } from '@/features/sped-fiscal/page/listagem/SpedFiscalListagem';

export const Route = createFileRoute('/a/sped-fiscal/')({
    component: SpedFiscalListagem,
});
